module.exports = __webpack_public_path__ + "img/logo.aeca1f76.jpeg";